import { PhonePipe} from './phone.pipe';
import { NgModule, ModuleWithProviders } from '@angular/core';

@NgModule({
  imports: [],
  declarations: [
    PhonePipe
  ],
  exports: [
    PhonePipe
  ]
})
export class PhonePipeModule{

  static forRoot(): ModuleWithProviders<PhonePipeModule> {
    return {
        ngModule: PhonePipeModule,
        providers: [],
    };
}
}
